import { useTranslation } from "react-i18next"

const NoPublishedTickets = () => {
  const { t } = useTranslation()

  return (
    <div className="text-center mt-10">
      <h1 className="text-2xl">{t("tickets.no_published_tickets", "No tickets are currently published")}</h1>
      <p>
        {t("tickets.publish_required", "At least one ticket must be published before you can use registration.")}
      </p>
    </div>
  )
}

NoPublishedTickets.displayName = "NoPublishedTickets"

export { NoPublishedTickets }
